import React from "react";
import SEO from "../components/Seo";
import { graphql, Link } from "gatsby";
import moment from "moment";

import Layout from "../components/Layout";
import Share from "../components/Share";

import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SimilarArticles from '../components/SimilarArticles';
import SocialLinks from '../components/SocialLinks';
import Header from '../components/Header';
import BackgroundImage from 'gatsby-background-image';


const PostTemplate = ({ data, location, navigate, pageContect, pageResources, path, pageContext, uri, ...props }) => {
  //console.log(data, location, navigate, pageContect, pageResources, path, pageContext, uri, props);
  return (
    <>
    <SEO
      title={data.post.frontmatter.title}
      keywords={[
        ...(data.post.frontmatter.keywords || []),
        `${data.post.frontmatter.title}`
      ]}
      type="article"
      site={path.href}
        author={`${data.post.frontmatter.author} - ${data.post.frontmatter.authorLinkedin}`}
      image={data.post.frontmatter.cover.childImageSharp.fluid.src}
      description={data.post.frontmatter.description}
    />
    <Layout>

     
      <Header frontPage={false} />
 
      <header className="masthead postContainer">
        <div className="bg">
          {data.post.frontmatter.cover ? (
            <BackgroundImage
              Tag="div"
              fluid={[`linear-gradient(to bottom, rgba(3, 119, 173, 0.4) 0%, rgba(22, 22, 22, 0.7) 75%, #161616 100%)`,
                data.post.frontmatter.cover.childImageSharp.fluid]}
              className={"bgPost"}
            >
              <div className="container d-flex h-100 align-items-center">
                <div className="mx-auto text-center">
                  <h1 className="mx-auto my-0 heading">{data.post.frontmatter.title.split("\n").map(v=><div>{v}</div>)}</h1>
                  <h2 className="mx-auto mt-2 mb-5">{moment(data.post.frontmatter.date).format("LL")}
                    <p className="mx-auto mt-2 mb-5 author">by: <Link to={`/author/${data.post.frontmatter.author.replace(/ /g, "-").toLowerCase()}`}>{data.post.frontmatter.author}</Link></p>
                      <p className="mx-auto mt-2 mb-5 author">{Math.round(data.post.fields.readingTime.words / 250)} min read</p>
                  </h2>
                  <div className="mx-auto mt-2 mb-5 share">
                    <Share
                      socialConfig={{
                        config: {
                          url: `${location.href}`, /*${socialConfigss.slug}*/
                          title: `${data.post.frontmatter.title}`
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </BackgroundImage>
          ) : (
              <div className="no-image"></div>
            )}
        </div>
      </header>

      <div className="site-container blog-post">
        <div className="container h-100 align-items-center">
            <div className="row d-flex justify-content-center">
            <div className="details">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.post.html
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="writtenBy text-center col-sm-12">
              <p className="author">WRITTEN BY <a rel="noreferrer" href={data.post.frontmatter.authorLinkedin} target="_blank">{data.post.frontmatter.author}</a> *  {moment(data.post.frontmatter.date).format("LL")}</p>
            </div>
          </div>

          <div className="row">
            <div className="socialMediaContent text-center col-sm-12">
              <h4>Do you know someone else that will enjoy this article?</h4>
              <Share
                socialConfig={{
                  config: {
                    url: `${location.href}`, /*${socialConfigss.slug}*/
                    title: `${data.post.frontmatter.title}`
                  }
                }}
              />
            </div>
          </div>
        </div> 
        <Contact bg="light" title="Find out more" subtitle="What you have seen so far is just the tip of the Iceberg" capture={true} />
        <div className="container h-100 align-items-center">  
          <div className="row">
            <div className="relatedArticles col-sm-12 text-center">
              <h2 className="title">Let's continue the journey</h2>
              <h4 className="subtitle">We also recommend the following articles</h4>
              <SimilarArticles keywords={data.post.frontmatter.keywords} slug={pageContext.slug} displaySomething={true} />
            </div>
          </div>
        </div>
      </div>
      <SocialLinks />
      <Footer />
    </Layout >
    </>
  );

}

export default PostTemplate;

export const postQuery = graphql`
  query PostBySlug($slug: String!) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
        prefix
        readingTime {
          words
        }
      }
      frontmatter {
        title
        author
        category,
        date,
        author,
        authorLinkedin,
        description,
        keywords,
        slug,
        cover {
          childImageSharp {
            fluid(maxWidth: 1200, maxHeight: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }      
      }
    }
    authornote: markdownRemark(fileAbsolutePath: { regex: "/author/" }) {
      id
      html
    }
  }
`;
